import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

export default {
    css: css`
        html {
            scroll-behavior: smooth;
        }
        body {
            font-size: ${TYPOGRAPHY.size.small};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            font-family: ${TYPOGRAPHY.fontFamily.base};
            color: ${getColor("text.main")};
        }
        .signInContainerRow {
            margin-top: 28px;
        }
        .menu-container {
            > div[class^="GridOffset"] {
                > div[class^="GridItemStyle"]:last-child {
                    > div[class^="Wrapper"] {
                        display: flex;
                        justify-content: space-between;
                        gap: 28px;
                        > div {
                            width: 25%;
                        }
                    }
                }
            }
        }
        .fullWidth {
            max-width: 100% !important;
            margin: 0 auto;
        }
        .max-width-container {
            max-width: 1280px !important;
            margin: 0 auto;
        }
        .max-widthClass {
            max-width: calc(100% - 80px);
            margin: 0 auto;
        }
        .max-width-class {
            width: calc(100% - 160px);
            max-width: 1280px !important;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                        width: calc(100% - 40px);
                        max-width: 1280px !important;
                    `,
                css`
                        width: calc(100% - 40px);
                        max-width: 1280px !important;
                    `,
                css`
                        width: calc(100% - 80px);
                        max-width: 1280px !important;
                    `,
                null,
                null,
            ])}
        }
        .megaMenuLinkHighlighted {
            color: #db293f !important;
            span {
                color: #db293f !important;
            }
        }
        .PLP-item-center {
            > div:first-of-type {
                display: flex;
                align-items: center;
            }
        }
        .mobile-colors-size {
            > div[class^="GridOffset"] {
                ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                            display: contents;
                        `,
                css`
                            display: contents;
                        `,
                css`
                            display: contents;
                        `,
                null,
                null,
            ])}
            }
        }
        .Colors-size {
            > div[class^="GridOffset"] {
                max-width: 100%;
                /* margin-top:8px; */
            }
        }
        .Product-Availibity-Quantity {
            margin-top: 17px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                        margin-top: 24px;
                    `,
                css`
                        margin-top: 24px;
                    `,
                css`
                        margin-top: 24px;
                    `,
                null,
                null,
            ])};
            > div[class^="GridOffset"] {
                max-width: 100%;
                > div[class^="GridItemStyle"] {
                    width: 100%;
                    > div[class^="Wrapper"] {
                        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                    flex-direction: column;
                                    align-items: flex-start;
                                    gap: 15px;
                                `,
                null,
                null,
                null,
                null,
            ])};

                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        /* gap: 22px; */
                        > div > div > label {
                            margin-right: 11px;
                        }
                    }
                }
            }
        }
        .margin-bottom-50 {
            margin-bottom: 50px;

            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                        padding: 0 20px;
                    `,
                css`
                        padding: 0 20px;
                    `,

                null,
                null,
                null,
            ])}
        }
        .Shop-Our-Ads-Row {
            > div[class^="GridOffset"] {
                max-width: 980px;
                margin: 0 auto;
                gap: 50px;
                ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                            gap: 40px;
                            justify-content: center;
                        `,
                null,
                null,
            ])}
                > div[class^="GridItemStyle"] {
                    flex-basis: 47.4%;
                    max-width: 47.4%;
                    div[class^="img-wrapper"] {
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                /* flex-basis: 45.4%;
                                max-width: 45.4%; */
                                flex-basis: 100%;
                                max-width: 100%;
                            `,
                css`
                                /* flex-basis: 45.4%;
                                max-width: 45.4%; */
                                flex-basis: 100%;
                                max-width: 100%;
                            `,
                css`
                                flex-basis: 44.4%;
                                max-width: 44.4%;
                                justify-content: center;
                                align-items: center;
                            `,
                null,
                null,
            ])}
                }
            }
        }
        .Shop-Our-Ads-Row-FourImages {
            > div[class^="GridOffset"] {
                > div[class^="GridItemStyle"] {
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                flex-basis: 50%;
                                max-width: 50%;
                            `,
                css`
                                flex-basis: 50%;
                                max-width: 50%;
                            `,
                null,
                null,
                null,
            ])}
                }
            }
        }
        .Add-to-Cart-List {
            > div[class^="GridOffset"] {
                max-width: 100%;
                > div[class^="GridItemStyle"] {
                    width: 100%;
                    > div[class^="Wrapper"] {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        gap: 20px;
                        width: auto;
                        /* > button {
                            width: 100%;
                        }
                        > div {
                            width: 100%;
                        } */
                    }
                }
            }
        }
        .product-data-page {
            > div[class^="GridOffset"] {
                ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                            display: flex;
                            flex-direction: column-reverse;
                            justify-content: center;
                            align-items: center;
                        `,
                css`
                            display: flex;
                            flex-direction: column-reverse;
                            justify-content: center;
                            align-items: center;
                        `,
                css`
                            display: flex;
                            flex-direction: column-reverse;
                            justify-content: center;
                            align-items: center;
                        `,
                css``,
                css``,
            ])}
                > div[class^="GridItemStyle"]:first-child {
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                padding-top: 0;
                                padding-bottom: 0;
                                max-width: 100% !important;
                                flex-basis: 100% !important;
                                width: 100% !important;
                            `,
                css`
                                padding-top: 0;
                                padding-bottom: 0;
                                max-width: 100% !important;
                                flex-basis: 100% !important;
                                width: 100% !important;
                            `,
                css`
                                max-width: 100% !important;
                                flex-basis: 100% !important;
                                width: 100% !important;
                                padding-top: 0;
                                padding-bottom: 0;
                            `,
                null,
                null,
            ])}
                }
                > div[class^="GridItemStyle"]:last-child {
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                width: 100%;
                                padding: 0px;
                            `,
                css`
                                width: 100%;
                                padding: 0px;
                            `,
                css`
                                width: 100%;
                                padding: 0px;
                            `,
                null,
                null,
            ])}
                }
            }
        }
        .mobile-view-Add-to-Cart {
            /* > div[class^="GridOffset"] {
                max-width: 100%;
                button {
                    padding: 10px 40px;
                    width: 100%;
                }
            } */
            > div > div > div {
                ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                        button{
                            margin-right: 20px;
                        }
                        div{
                        display:inline-block;
                        }
                        button[aria-label^="Add to Project"]{
                         margin-top:10px;
                        }
                       
                        `,
                css`
                            display: flex;
                            gap: 20px;                        `,
                css`
                            display: flex;
                            gap: 20px;
                            > a {
                                width: 50%;
                            }
                            > div {
                            }
                        `,
                null,
                null,
            ])}
            }
        }
        .mobile-view-Add-to-List {
            > div[class^="GridOffset"] {
                max-width: 100%;
                > div[class^="GridItemStyle"] {
                    > div[class^="Wrapper"] {
                        > div {
                            width: 100%;
                        }
                    }
                }
            }
        }
        .plp-mob-full-width {
            > div {
                ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                            display: none !important;
                        `,
                css`
                            display: none !important;
                        `,
                css`
                            display: none !important;
                        `,
                null,
                null,
            ])}
            }
        }
        .graybg {
            background-color: ${COLORS.grayBg};
        }
        .lightgraybg {
            background-color: ${COLORS.lightGrayBg};
        }
        .button-alignment {
            > div {
                width: 100% !important;
                justify-content: space-between !important;
                > div {
                    max-width: 49% !important;
                    flex-basis: 49% !important;
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                max-width: 100% !important;
                                flex-basis: 100% !important;
                            `,
                css`
                                max-width: 100% !important;
                                flex-basis: 100% !important;
                            `,
                null,
                null,
                null,
            ])}
                    > div > div {
                        margin-bottom: 16px;
                        > div > button {
                            width: 100%;
                            //border-radius: 6px;
                            &:hover {
                                background-color: ${COLORS.Matterhorn} !important;
                            }
                        }
                    }
                }
            }
        }
        .Product-caraousal-width {
            max-width: 1280px !important;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                        max-width: 1280px !important;
                    `,
                css`
                        max-width: 1280px !important;
                    `,
                css`
                        max-width: 1280px !important;
                    `,
                null,
                null,
            ])}
        }
        .Custom-Product-width {
            padding: 0px 10px;
        }
        .max-width-class-955 {
            max-width: 955px;
            width: 100%;
            margin: 0 auto;
        }
        .border-gap {
            border-top: 10px solid ${COLORS.secondary.base};
        }
        .full-width-extend {
            width: calc(100vw - 20px);
            margin-left: calc(-50vw + 50% + 10px);
            max-width: calc(100vw - 20px);
        }
        div[data-test-selector^="page_ProductListPage"] {
            footer {
                > div[class^="Wrapper"] {
                    > div[class^="sc"] {
                        margin-top: 0 !important;
                    }
                }
            }
        }
        div[data-test-selector^="page_HomePage"] {
            footer {
                > div[class^="Wrapper"] {
                    > div[class^="sc"] {
                        margin-top: 0 !important;
                    }
                }
            }
        }
        div[data-test-selector^="page_Page"] {
            footer {
                > div[class^="Wrapper"] {
                    > div[class^="sc"] {
                        margin-top: 0 !important;
                    }
                }
            }
        }
        div[data-test-selector^="page_NewsListPage"] {
            footer {
                > div[class^="Wrapper"] {
                    > div[class^="sc"] {
                        margin-top: 0 !important;
                    }
                }
            }
        }
        div[data-test-selector^="page_ProductDetailsPage"] {
            main {
                padding: 0px !important;
                //overflow: hidden;
                .max-width-container {
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                padding: 20px !important;
                            `,
                css`
                                padding: 20px !important;
                            `,
                css`
                                padding: 20px !important;
                            `,
                null,
                null,
            ])}
                }
            }
        }
        div[data-test-selector^="page_NewsPage"] {
            main {
                padding: 0px !important;
                max-width: 100% !important;
                margin: 0px auto !important;
                .max-width-container {
                    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                                padding: 20px !important;
                                padding-bottom: 0px !important;
                            `,
                css`
                                padding: 20px !important;
                                padding-bottom: 0px !important;
                            `,
                css`
                                padding: 20px !important;
                                padding-bottom: 0px !important;
                            `,
                null,
                null,
            ])}
                }
            }
            footer {
                > div[class^="Wrapper"] {
                    > div[class^="sc"] {
                        margin-top: 0 !important;
                    }
                }
            }
        }
        .pd-20 {
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                            padding: 0px;
                        `,
                    css`
                            padding: 0px;
                        `,
                    css`
                            padding: 0px;
                        `,
                    css`
                            padding: 20px;
                        `,
                    css`
                            padding: 20px;
                        `,
                ],
                "min",
            )}
        }
        .pd-0 {
            padding: 0 !important;
        }
        .mt-10 {
            margin-top: 10px !important;
        }
    `,
};
